import { createContext, useContext } from "react";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { useAccount } from "./AccountContext";
import { DEFAULT_VIEW } from "../configs/viewOptions";

// One global bookmark-list view preference applied everywhere (Bookmarks page,
// collection detail, …), persisted to localStorage. Falls back to an account
// preference the first time if one is set, otherwise the default list view.
const ViewContext = createContext(null);

const VALID_VIEWS = ["list", "headlines", "cards"];

export const ViewProvider = ({ children }) => {
  const { account } = useAccount();

  const initial =
    (account?.preferences && account.preferences.bookmarksView) || DEFAULT_VIEW;

  const [stored, setStored] = useLocalStorage("onBookmarksView", initial);
  const view = VALID_VIEWS.includes(stored) ? stored : DEFAULT_VIEW;

  const setView = (next) => {
    if (VALID_VIEWS.includes(next)) {
      setStored(next);
    }
  };

  return (
    <ViewContext.Provider value={{ view, setView }}>
      {children}
    </ViewContext.Provider>
  );
};

export const useView = () => {
  const ctx = useContext(ViewContext);
  if (!ctx) {
    throw new Error("useView must be used within a ViewProvider");
  }
  return ctx;
};
